
<template>
  <div id="form-service">
    <div class="container">
      <div class="form mx-auto" :class="{ faded: submittitng }">
          <transition name="animation" mode="out-in">
              <div v-if="!formSubmitted" class="form-wrapper">
                <h2 class="title-sm mb-4">{{ $t('Get insurance') }}</h2>
                  <p v-if="description" class="description mb-4">{{ description }}</p>
                <form @submit.prevent="submitForm" class="row">
                  <div class="col-12 form-group">
                    <label for="name">{{ $t('Name and surname') }}<span class="text-danger">*</span></label>
                    <input type="text" id="name" v-model="formData.name" required class="form-control" name="name">
                  </div>
                  <div class="col-md-6 col-12 form-group">
                    <label for="email">{{ $t('Email') }}<span class="text-danger">*</span></label>
                    <input type="email" id="email" v-model="formData.email" required class="form-control" name="email">
                  </div>
                  <div class="col-md-6 col-12 form-group">
                    <label for="phone">{{ $t('Phone') }}<span class="text-danger">*</span></label>
                    <input type="text" id="phone" v-model="formData.phone" required class="form-control" name="phone">
                  </div>
                  <div class="col-12 form-group">
                    <label for="message">{{ $t('Your message') }}<span class="text-danger">*</span></label>
                    <textarea id="message" v-model="formData.message" required class="form-control" rows="4" name="message"></textarea>
                  </div>
                  <div class="d-flex justify-content-between mt-4 flex-column flex-md-row gap-4">
                    <div v-if="gdprLink">
                      <div class="form-check mb-2">
                        <input type="checkbox" id="gdpr" v-model="formData.gdpr" name="gdpr" class="check-input">
                        <label for="gdpr" v-html="gdprLink" class="mb-0"></label>
                      </div>
                      <!-- info sekcia z content editora -->
                      <div v-if="info" class="info">{{ info }}</div>
                    </div>
                    <button :disabled="submittitng" type="submit" class="btn btn-primary">{{ $t('Send') }}</button>
                  </div>
                    <!-- loading ikonka - zobrazi sa pocas odosielania formulara -->
                    <div v-if="submittitng" class="loading-icon"></div>
                </form>
                  <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
              </div>
              <!-- Message -->
              <div v-else class="submitted-message mx-auto text-center text-md-start mt-0">
                  <h2 class="title-sm">{{ $t('Thank you, your request has been successfully sent') }}</h2>
                  <p class="mb-4">
                      {{ $t('Our expert will contact you within 2 hours') }}
                  </p>
                  <div class="phone-box">
                      <strong>
                        {{ $t('Our expert will contact you on one of the numbers') }}
                      </strong>
                      <div v-if="phoneNumbers" class="phone d-flex flex-column flex-md-row">
                        <a v-for="(number, index) in phoneNumbersArray" :href="`tel:${number}`" :key="index">{{ number }}</a>
                      </div>
                  </div>
              </div>
          </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        actionUrl: {
            type: String,
        },
        description: {
            type: String,
            default: null
        },
        info: {
            type: String,
            default: null
        },
        gdprLink: {
            type: String,
            default: null
        },
        phoneNumbers: {
            type: String,
            default: null
        },
    },
  data() {
    return {
      formData: {
        name: '',
        email: '',
        phone: '',
        message: '',
        gdpr: false,
      },
        submittitng: false,
      formSubmitted: false,
        errorMessage: null
    };
  },
    computed: {
        phoneNumbersArray() {
            return this.phoneNumbers ? JSON.parse(this.phoneNumbers) : null;
        }
    },
  methods: {
    submitForm() {
        this.submittitng = true;
        this.errorMessage = null;

        axios.post(this.actionUrl, this.formData).then(response => {
            this.submittitng = false;

            if (response.data.success) {
                // odoslanie formu prebehlo uspesne
                this.formSubmitted = true;
                this.resetForm();
                let scrollPos = document.querySelector('.form').offsetTop;
                window.scrollTo({ top: scrollPos - 200, behavior: 'smooth' });
            } else {
                // nastala chyba na strane servera
                this.errorMessage = response.data.message;
            }
            // nepresla validacia formulara
        }).catch(error => {
            this.submittitng = false;
            this.errorMessage = error.response.data.message;
        });
    },
    resetForm() {
      this.formData.name = '';
      this.formData.email = '';
      this.formData.phone = '';
      this.formData.message = '';
      this.formData.gdpr = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.error-message {
    background-color: #ff000011;
    color: #ff0000dd;
    border: 1px solid #ff000022;
    margin-top: 15px;
    padding: 20px;
}
.animation-enter-active,
.animation-leave-active {
    transition: all .3s ease;
}
.animation-enter-from,
.animation-leave-to {
    transform: translateY(-400px);
    opacity: 0;
}

.loading-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.loading-icon::before {
  content: "";
  display: block;
  width: 60px;
  height: 60px;
  border: 5px solid #dcd9ce;
  border-top: 5px solid #DDB96F;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}



</style>